<footer>
  <div>&copy; {{ 'main-navigation.copyright' | translate: {year: getYear()} }}</div>
  <a href="javascript:void(0);" data-testid="oes-terms-link" (click)="openTerms()">
    {{'main-navigation.terms' | translate}}
  </a>
</footer>
